import React from 'react';
import {
  Container,
  Header,
  SpaceBetween,
  FormField,
  Input,
  DateRangePicker,
  Select,
  Multiselect,
} from "@cloudscape-design/components";
import { ALL_SUPERVISORS_OPTION } from '../../constants/insightsConstants';

/**
 * Componente del formulario de configuración de resumen
 */
export default function SummaryConfigurationForm({
  summaryName,
  dateRange,
  selectedSupervisor,
  selectedAgents,
  supervisors,
  agents,
  supervisorsEnabled,
  agentsEnabled,
  onSummaryNameChange,
  onDateRangeChange,
  onSupervisorChange,
  onAgentsChange,
  getAgentsPlaceholder,
  t
}) {
  return (
    <Container
      header={
        <Header variant="h2" description={t("insights.configureSummaryDescription")}>
          {t("insights.configureSummary")}
        </Header>
      }
    >
      <SpaceBetween size="m">
        <div style={{ width: '60%' }}>
          <FormField 
            label={t("insights.summaryName") + " *"}
            constraintText={t("insights.required")}
            stretch
          >
            <Input
              value={summaryName}
              onChange={({ detail }) => onSummaryNameChange(detail.value)}
              placeholder={t("insights.summaryNamePlaceholder")}
              ariaRequired={true}
            />
          </FormField>
        </div>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-end' }}>
          <div style={{ flex: '0 0 60%' }}>
            <FormField label={t("common.selectDateRange") + " *"} stretch>
              <DateRangePicker
                onChange={({ detail }) => onDateRangeChange(detail.value)}
                value={dateRange}
                placeholder={t("common.selectDateRange")}
                i18nStrings={{
                  todayAriaLabel: t("common.today"),
                  nextMonthAriaLabel: t("common.nextMonth"),
                  previousMonthAriaLabel: t("common.previousMonth"),
                  customRelativeRangeDurationLabel: t("common.duration"),
                  customRelativeRangeOptionLabel: t("common.customRange"),
                  customRelativeRangeOptionDescription: t("common.customRangeDescription"),
                  customRelativeRangeUnitLabel: t("common.unit"),
                  formatRelativeRange: (e) => t("common.relativeRange", e),
                  formatUnit: (e, n) => t("common.unit", { unit: e, count: n }),
                  dateTimeConstraintText: t("common.dateTimeConstraint"),
                  relativeModeTitle: t("common.relativeMode"),
                  absoluteModeTitle: t("common.absoluteMode"),
                  relativeRangeSelectionHeading: t("common.relativeRangeSelection"),
                  startDateLabel: t("common.startDate"),
                  endDateLabel: t("common.endDate"),
                  startTimeLabel: t("common.startTime"),
                  endTimeLabel: t("common.endTime"),
                  clearButtonLabel: t("common.clear"),
                  cancelButtonLabel: t("common.cancel"),
                  applyButtonLabel: t("common.apply")
                }}
              />
            </FormField>
          </div>
          <div style={{ flex: '0 0 15%' }}>
            <FormField 
              label={t("insights.supervisor")}
              stretch
            >
              <Select
                selectedOption={selectedSupervisor ? { 
                  value: selectedSupervisor, 
                  label: selectedSupervisor 
                } : { 
                  value: ALL_SUPERVISORS_OPTION, 
                  label: t("insights.all")
                }}
                onChange={({ detail }) => {
                  const newValue = detail.selectedOption?.value;
                  // Si se selecciona "Todos" (__ALL__), limpiar supervisor
                  // El componente padre manejará la limpieza de agentes
                  onSupervisorChange(newValue === ALL_SUPERVISORS_OPTION ? null : newValue);
                }}
                options={[
                  { value: ALL_SUPERVISORS_OPTION, label: t("insights.all") },
                  ...supervisors
                ]}
                disabled={!supervisorsEnabled || !dateRange}
                placeholder={t("insights.all")}
                empty={t("insights.noSupervisorsAvailable")}
                filteringType="auto"
                selectedAriaLabel={t("insights.supervisorSelected")}
              />
            </FormField>
          </div>
          <div style={{ flex: '0 0 15%' }}>
            <FormField 
              label={t("insights.agent")}
              stretch
            >
              <Multiselect
                options={[{ label: t("insights.all"), options: agents }]}
                selectedOptions={agents.filter(opt => selectedAgents.includes(opt.value))}
                onChange={({ detail }) => {
                  const values = (detail.selectedOptions || []).map(option => option.value);
                  onAgentsChange(values);
                }}
                disabled={!agentsEnabled}
                placeholder={getAgentsPlaceholder(selectedAgents)}
                empty={t("insights.noAgentsAvailable")}
                hideTokens
                inlineTokens
              />
            </FormField>
          </div>
        </div>
      </SpaceBetween>
    </Container>
  );
}

